export default () => ({
  all: [],
  current: null,
  extrasFilter: {
    query: '',
    category: '',
    remoteId: '',
    status: '',
    priceMin: '',
    priceMax: '',
    image: null,
    text: null,
    inStock: false,
    outOfStock: false,
    noCategory: false,
    inStockAtVendor: null,
    vendorNo: '',
  },
  newCarsFilter: {
    query: '',
    remoteId: '',
    registrationNumber: '',
    status: '',
    priceMin: '',
    priceMax: '',
    image: null,
    text: null,
    inStock: false,
    outOfStock: false,
    fuel: null,
    make: null,
    model: null,
    statusCode: null,
    salesRoute: null,
  },
  modelsFilter: {
    query: '',
    model: '',
    status: '',
  },
  sort: 'title',
  meta: {
    next: null,
    previous: null,
    rowCount: 0,
  },
});
